import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()

//cv reviewer - resume
export const getCvreviewer = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/user`, config)
}

//billing status - resume
export const getBilling= async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/BillingStatus`, config)
}
